package pogolitics

const val applicationRoot = "" // "/pogoliticsd"

external val resourcesVersion: String
